import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=35870360&"
import script from "./indexManage.vue?vue&type=script&lang=js&"
export * from "./indexManage.vue?vue&type=script&lang=js&"
import style0 from "./indexManage.vue?vue&type=style&index=0&id=35870360&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports